<template>
  <div>
    <v-container>
      <h1>{{ title }}</h1>
      <v-row>
        <v-col cols="12" md="4" offset-md="8" xs="12" sm="6" offset-sm="6">
          <v-text-field label="Search" v-model="search"></v-text-field>
        </v-col>
      </v-row>
      <v-data-table :items="items" :headers="headers" :search="search">
        <template v-slot:item.actions="{ item }">
          <v-btn icon text color="primary" @click.stop="edit(item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-container>
    <v-dialog v-model="dialog" width="900" persistent>
      <v-card>
        <v-card-title>
          <span
            >{{ selected.refSeq }} - Transaction No.
            {{ selected.transactionNo }}</span
          >
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
              <v-text-field
                :value="selected.fullName"
                label="Employee"
                :class="classPadding"
              ></v-text-field>
            </v-col>

            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <v-text-field
                label="Date Hired"
                :class="classPadding"
                :value="dateHired"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <v-text-field
                :value="selected.desDesc"
                label="Designation"
                :class="classPadding"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <v-text-field
                :value="selected.depDesc"
                label="Department"
                :class="classPadding"
              ></v-text-field>
            </v-col>

            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <v-text-field
                :value="selected.secDesc"
                label="Section"
                :class="classPadding"
              ></v-text-field>
            </v-col>

            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <v-text-field
                :value="selected.movementTypeDesc"
                label="Movement Type"
                :class="classPadding"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <br />
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="6" :class="classPadding">
              <v-checkbox
                label="Complete"
                :class="classPadding"
                v-model="model.complete"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6" :class="classPadding">
              <custom-datepicker
                :class-padding="classPadding"
                label="Completed Date"
                v-model="model.completedDate"
              ></custom-datepicker>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
              <v-text-field
                label="Remarks"
                :class="classPadding"
                v-model="model.remarks"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
              <v-file-input
                label="Attachment"
                ref="webLogoReports"
                v-model="attachment"
                :class="classPadding"
              ></v-file-input>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.stop="submit" color="success" text :loading="isLoading"
            >Submit</v-btn
          >
          <v-btn
            @click.stop="dialog = false"
            color="error"
            text
            :loading="isLoading"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import CustomDatepicker from "@/components/CustomDatepicker";
import { headers } from "./variables";
import { isNullOrUndefined } from "@/validation/validation.js";
import moment from "moment";
import isEmpty from "lodash/isEmpty";
const API_ENDPOINT = "/api/onboardingCompletion";
export default {
  metaInfo: {
    title: "Onboarding Plan Setup Completion",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`,
  },
  data: () => ({
    title: "Onboarding Plan Setup Completion",
    classPadding: "my-0 py-0",
    items: [],
    headers,
    dialog: false,
    seletedIndex: -1,
    selected: {},
    model: {},
    attachment: null,
    attachmentDialog: false,
    search: null,
    dateHired: "",
    isLoading: false,
  }),
  components: {
    CustomDatepicker,
  },
  methods: {
    getForCompletion() {
      this.$axios
        .get(`${API_ENDPOINT}`)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    edit(item) {
      this.selectedIndex = this.items.indexOf(item);
      this.selected = item;
      this.dialog = true;
    },
    submit() {
      this.isLoading = true;
      var param = {
        id: this.selected.id,
        transNo: this.selected.transactionNo,
        ...this.model,
      };

      var formData = new FormData();
      var data = Object.assign({}, param);
      formData.append("json", JSON.stringify(data));
      formData.append("attachment", this.attachment);

      this.$axios({
        method: "POST",
        url: `${API_ENDPOINT}`,
        data: formData,
        config: {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      })
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.dialog = false;
          this.getForCompletion();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getEmpInfo(empCode) {
      this.$axios
        .get(`/api/employmentInfo/${empCode}`)
        .then(({ data }) => {
          if (!isEmpty(data))
            this.dateHired = moment(data.dateHired).format("MM/DD/YYYY");
          else this.dateHired = "";
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    reset() {
      this.seletedIndex = -1;
      this.selected = {};
      this.model = {};
      this.attachment = null;
    },
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.reset();
      }
    },
    selected(val) {
      if (!isNullOrUndefined(val.empCode)) this.getEmpInfo(val.empCode);
    },
  },
  created() {
    this.getForCompletion();
  },
};
</script>
